import { render, staticRenderFns } from "./SuccessFeedback.vue?vue&type=template&id=4138f98c&"
import script from "./SuccessFeedback.vue?vue&type=script&lang=ts&"
export * from "./SuccessFeedback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports